import fetch from '@public/http/request'
import { GATEWAY } from '@/common/config/index'
// import { GATEWAYSER } from '@/common/config/index'

export const WaybillTagContentApi = {
  // 运单标签
  reqWaybillTag(reqData) {
    return fetch.post(`${GATEWAY.SER}/receivePreference/query`, reqData,{ headers:{'systemtype':'OUTSOURCE'}})
  },
  // 收货偏好枚举
  reqAllWaybillTag(reqData) {
    return fetch.post(`${GATEWAY.SER}/receivePreference/queryAllReceiveLabels`, reqData,{ headers:{'systemtype':'OUTSOURCE'}})
  },
  // 设置收货偏好
  reqUpdateWaybillTag(reqData) {
    return fetch.post(`${GATEWAY.SER}/receivePreference/set`, reqData,{ headers:{'systemtype':'OUTSOURCE'}})
  },
  // 查询设置的偏好
  reqReceiveLabelsCode(reqData) {
    return fetch.post(`${GATEWAY.SER}/receivePreference/queryReceiveLabelsCode`, reqData,{ headers:{'systemtype':'OUTSOURCE'}})
  }
  // reqExcel(reqData) {
  //   return fetch.post(`${moduleList.loginOnlineLog}/hq/export/async`, reqData, { responseType: 'arraybuffer' }).then(res => res)
  // }
}

